<template>
<modal :show="show">
    <div class="modal-header border-0">
        <h5 class="modal-title">Rename Upload</h5>
        <button @click="close" type="button" class="close btn btn-round">
            <i class="icon icon-close"></i>
        </button>
    </div>
    <div class="modal-body p-4 overflow-auto">
        <label>Name</label>
        <input v-model="editedName" @keydown.enter.prevent="next" ref="name" class="form-control mb-4" />
        <label>Extension</label>
        <input v-model="extension" @keydown.enter.prevent="confirm" ref="extension" class="form-control mb-4" />
    </div>

    <div class="modal-footer border-0">
        <button class="btn btn-white btn-sm" @click="confirm">
            OK
        </button>
    </div>
</modal>
</template>

<script>
import Modal from "@/../submodules/vue-base/components/Modal";

export default {

    name: 'RenameUploadModal',


    components: {
        Modal
    },

    data() {
        return {
            show: false,
			filename: "",
            editedName: "",
            extension: "",
        }
    },

    methods: {
        open() {
            
            this.extension = this.filename.split('.').pop();
			this.editedName = this.filename.slice(0,-this.extension.length);
			if (this.editedName[this.editedName.length-1] === "."){
				this.editedName = this.editedName.slice(0,-1);
			}

            this.show = true;

			var temp=this;
			setTimeout(function(){
				temp.$refs.name.focus();
			},0)
        },


		next(){
			this.$refs.extension.focus();
		},

        close() {
            this.show = false
        },

        confirm() {

			var newname = this.editedName;

            if (this.extension != "") {
                newname += "." + this.extension;
            }

			this.$emit("confirm",newname)
			this.close();
        }
    }
}
</script>
